import React from 'react';
import './InlineStat.scss';

interface InlineStatProps {
  icon: string;
  title: string;
  value: number | string;
  unit: string;
  alt?: string;
  name?: string;
  headerThemeClass?: string;
  topHeaderThemeClass?: string;
  valueThemeClass?: string;
}


const InlineStat: React.FC<InlineStatProps> = ({ icon, title, value, unit, alt = 'stat-icon',name,headerThemeClass,topHeaderThemeClass,valueThemeClass }) => {
    return (
      <div className="inline-stat-box">
        <div className={`icon-container ${name === 'car' ? 'icon-car' : 'iconOther'}`}>
          <img src={icon} alt={alt} className="stat-icon" />
        </div>
        <div className="inline-stat-text">
          <div className="line-1">
            <span className={`title ${topHeaderThemeClass}`}>{title}</span>
          </div>
          <div className="line-2">
            <span className={`value ${valueThemeClass}`}>{value}</span>
            <span className={`unit-text ${headerThemeClass} ${name === 'car' ? 'unit-text-car' : 'unit-text-all'}` }>{unit}</span>
          </div>
        </div>
      </div>
    );
  };
export default InlineStat;